import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DialogPathService {
  private pathStack = new BehaviorSubject<string[]>([]);

  get path(): string[] {
    return this.pathStack.value;
  }

  get title(): string {
    return this.pathStack.value.join(' > ');
  }

  push(title: string) {
    this.pathStack.next([...this.pathStack.value, title]);
  }

  pop() {
    const path = this.pathStack.value;
    this.pathStack.next(path.slice(0, -1));
  }

  reset() {
    this.pathStack.next([]);
  }
}
